module.exports = __webpack_public_path__ + "img/screen-chat-options.201b2054.jpg";